import { render, staticRenderFns } from "./RoleEditPage.vue?vue&type=template&id=424775e8&scoped=true"
import script from "./RoleEditPage.vue?vue&type=script&lang=js"
export * from "./RoleEditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424775e8",
  null
  
)

export default component.exports